import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cards from './es/cards.json';
import common from './es/common.json';
import errors from './es/errors.json';
import rules from './es/rules.json';
import wonders from './es/wonders.json';

void i18n.use(initReactI18next).init({
  lng: 'es',
  fallbackLng: 'es',
  defaultNS: 'common',
  ns: ['common', 'cards', 'wonders', 'errors', 'rules'],
  resources: { es: { common, cards, wonders, errors, rules } },
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;

export const cardName = (defId: string) => i18n.t(defId, { ns: 'cards' });
export const wonderName = (id: string, full = false) => i18n.t(`${id}.${full ? 'full' : 'short'}`, { ns: 'wonders' });
export const errorText = (code: string, params?: Record<string, unknown>) =>
  i18n.t(code, { ns: 'errors', defaultValue: code, ...(params ?? {}) });
